export var IBrandCartV2;
(function (IBrandCartV2) {
    let State;
    (function (State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        /**
         * The total of the brand cart is above brand's minimum but below maximum.
         */
        State["READY_FOR_CHECKOUT"] = "READY_FOR_CHECKOUT";
        /**
         * The total of the brand cart is above brand's maximum.
         */
        State["ABOVE_MAXIMUM"] = "ABOVE_MAXIMUM";
        /**
         * The total of the brand cart is below brand's minimum.
         */
        State["BELOW_MINIMUM"] = "BELOW_MINIMUM";
        /**
         * The brand is on vacation.
         */
        State["ON_VACATION"] = "ON_VACATION";
        /**
         * The brand cart is saved for later (and thus not checked out as a part of the overall cart).
         */
        State["SAVED_FOR_LATER"] = "SAVED_FOR_LATER";
    })(State = IBrandCartV2.State || (IBrandCartV2.State = {}));
    let FreeNudgeState;
    (function (FreeNudgeState) {
        FreeNudgeState["FREE_NUDGE_STATE_UNKNOWN"] = "FREE_NUDGE_STATE_UNKNOWN";
        FreeNudgeState["RETAILER_FIRST_ORDER_NUDGE"] = "RETAILER_FIRST_ORDER_NUDGE";
        FreeNudgeState["BRAND_FIRST_ORDER_NUDGE"] = "BRAND_FIRST_ORDER_NUDGE";
        FreeNudgeState["NO_NUDGE"] = "NO_NUDGE";
    })(FreeNudgeState = IBrandCartV2.FreeNudgeState || (IBrandCartV2.FreeNudgeState = {}));
    let FaireProtectionStatus;
    (function (FaireProtectionStatus) {
        FaireProtectionStatus["FAIRE_PROTECTION_STATUS_UNKNOWN"] = "FAIRE_PROTECTION_STATUS_UNKNOWN";
    })(FaireProtectionStatus = IBrandCartV2.FaireProtectionStatus || (IBrandCartV2.FaireProtectionStatus = {}));
    let IBrandCartReview;
    (function (IBrandCartReview) {
        /**
         * Return an instance of IBrandCartReview with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IBrandCartReview.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IBrandCartReview = IBrandCartV2.IBrandCartReview || (IBrandCartV2.IBrandCartReview = {}));
    let ReviewStatus;
    (function (ReviewStatus) {
        ReviewStatus["REVIEW_STATUS_UNKNOWN"] = "REVIEW_STATUS_UNKNOWN";
        ReviewStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    })(ReviewStatus = IBrandCartV2.ReviewStatus || (IBrandCartV2.ReviewStatus = {}));
    /**
     * Return an instance of IBrandCartV2 with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBrandCartV2.build = (partial) => (Object.assign({ cart_items: {}, brand_promos: [], disclaimers: [], shipment_groups: [], cart_items_tooltips: {} }, (partial !== null && partial !== void 0 ? partial : {})));
})(IBrandCartV2 || (IBrandCartV2 = {}));
